module.exports = __webpack_public_path__ + "img/fnf-logo-100.05d923e6.png";